import { getNavigatorLanguage } from '@monorepo/shared';

import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { Stack } from 'rsuite';

interface IProps {
  quotaHistoryData: Record<string, any>;
  localeVal: string;
}

export const QuotaHistory = ({ quotaHistoryData, localeVal }: IProps) => {
  return (
    <>
      <div
        style={{
          padding: '8px 12px',
          borderBottom: '1px solid rgba(32, 33, 36, 0.29)'
        }}
      >
        <b>{t('faz.organization.resource.historyTitle')}</b>
      </div>
      <div
        style={{
          padding: '8px 12px'
        }}
      >
        {quotaHistoryData?.quota_used_history?.length ? (
          quotaHistoryData.quota_used_history.map(
            (item: Record<string, string>, key: number) => (
              <Stack key={key}>
                <div style={{ width: '100px' }}>{item?.date}</div>
                <div>
                  <b style={{ fontSize: '1.1em', padding: '0 4px' }}>
                    {Number(item?.used).toFixed(2) || 0}
                  </b>
                  <span>{'GB'}</span>
                </div>
              </Stack>
            )
          )
        ) : (
          <div>{t('faz.organization.resource.historyNotAvailable')}</div>
        )}
      </div>
    </>
  );
};
